module.exports = ".mat-dialog-content {\n  max-height: none; }\n"